import * as Zod from 'zod';

export const cameraScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
